import {
    Card,
    CardContent,
    CardTitle,
    ItemList,
    Text,
    Icon,
    Badge,
    Popup,
    PopupTitle,
    PopupContent,
    Code,
    Callout,
    Button,
    Toast
} from "@tv2no/ui-react";
import React, { useEffect, useState } from "react";
import {
    fetchCountyListStatus,
    fetchMunicipalityListStatus,
    fetchZipCodeListStatus,
    syncCountyList,
    syncMunicipalityList,
    syncZipCodeList
} from "../../../api/services/geo-import";

export const GeoImport = () => {
    const [countyStatus, setCountyStatus] = useState({
        label: "Fylker",
        sync: syncCountyList
    });
    const [municipalityStatus, setMunicipalityStatus] = useState({
        label: "Kommuner",
        sync: syncMunicipalityList
    });
    const [zipCodeStatus, setZipCodeStatus] = useState({
        label: "Poststeder",
        sync: syncZipCodeList
    });
    const [selectedStatus, setSelectedStatus] = useState(null);
    const [busySyncing, setBusySyncing] = useState(false);

    useEffect(() => {
        // Counties
        setCountyStatus((obj) => ({ ...obj, busy: true }));
        fetchCountyListStatus()
            .then((response) => {
                setCountyStatus((obj) => ({ ...obj, busy: false, data: response }));
            })
            .catch((err) => {
                setCountyStatus((obj) => ({ ...obj, busy: false, data: null, error: err || true }));
            });

        // Municipalities
        setMunicipalityStatus((obj) => ({ ...obj, busy: true }));
        fetchMunicipalityListStatus()
            .then((response) => {
                setMunicipalityStatus((obj) => ({ ...obj, busy: false, data: response }));
            })
            .catch((err) => {
                setMunicipalityStatus((obj) => ({ ...obj, busy: false, data: null, error: err || true }));
            });

        // Zip codes
        setZipCodeStatus((obj) => ({ ...obj, busy: true }));
        fetchZipCodeListStatus()
            .then((response) => {
                setZipCodeStatus((obj) => ({ ...obj, busy: false, data: response }));
            })
            .catch((err) => {
                setZipCodeStatus((obj) => ({ ...obj, busy: false, data: null, error: err || true }));
            });
    }, []);

    const handleSyncList = (status) => {
        setBusySyncing(true);
        status.sync().then((response) => {
            setBusySyncing(false);
            Toast.success(`Opprettet ${response.length} ${status.label}`);
        });
    };

    return (
        <React.Fragment>
            <Card>
                <CardTitle title="Geografiske data - Import" />
                <CardContent>
                    <ItemList onItemClick={setSelectedStatus}>
                        {[countyStatus, municipalityStatus, zipCodeStatus].map((status, idx) => (
                            <ItemList.Item
                                key={idx}
                                index={idx}
                                value={status}
                                append={[
                                    status.busy ? (
                                        <Icon name="refresh" color="warning" rotate />
                                    ) : status.error ? (
                                        <Badge fill name="warning" color="error">
                                            Feilet
                                        </Badge>
                                    ) : (
                                        <Badge fill icon="check" color="success">
                                            Ok
                                        </Badge>
                                    ),
                                    <Button size="small" busy={busySyncing} onClick={() => handleSyncList(status)}>
                                        Synk
                                    </Button>
                                ]}
                            >
                                <Text block weight="medium">
                                    {status.label}
                                </Text>
                                {status.error ? (
                                    <Text size="small" color="error">
                                        Feil ved lasting av geo-data fra ekstern kilde.
                                    </Text>
                                ) : (
                                    <Text size="small" opacity={50}>
                                        {status.data?.endpoint || "..."}
                                    </Text>
                                )}
                            </ItemList.Item>
                        ))}
                    </ItemList>
                </CardContent>
            </Card>

            {selectedStatus && (
                <Popup onClose={() => setSelectedStatus(null)}>
                    <PopupTitle>{selectedStatus.label}</PopupTitle>
                    <PopupContent scrollable>
                        <Text size="small">
                            <Code>
                                <pre>{JSON.stringify(selectedStatus.data, null, 2)}</pre>
                            </Code>
                        </Text>
                    </PopupContent>
                    {selectedStatus?.error ? (
                        <PopupContent>
                            <Callout color="error">{selectedStatus.error?.message}</Callout>
                        </PopupContent>
                    ) : null}
                </Popup>
            )}
        </React.Fragment>
    );
};
